// extracted by mini-css-extract-plugin
module.exports = {"line":"Article_line__x1cWN","bgColumn":"Article_bgColumn__5QPXf","bgColumnAlt":"Article_bgColumnAlt__X3HPT","highlightText":"Article_highlightText__XYIWi"};